import Icon from '../../components/Icon.vue'

Icon.register({"brands/dropbox":{"width":528,"height":512,"paths":[{"d":"M264.4 116.3L132.4 200.6 264.4 284.9 132.4 369.2 0 284.1 132.3 199.8 0 116.3 132.3 32 264.4 116.3zM131.6 395.7L263.6 311.4 395.6 395.7 263.6 480 131.6 395.7zM264.4 284.1L396.4 199.8 264.4 116.2 395.7 32 528 116.3 395.7 200.6 528 284.8 395.7 369.1 264.4 284.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/dropbox.js
// module id = U1UT
// module chunks = 0